'use strict';

export const URL = 'https://api2.gdpr2.hu/api'; 
// TODO: replace before relase

